// Import firebase services
import { firebaseAuth, propertiesModel } from '@/firebase/firebase-config'

// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
import { GenerateUID } from '@/mixins/helpers/GenerateUID'

export const PropertyPurchasesRepository = {

	/*
	**  Register the mixins
	*/

	mixins: [

		BugsnagService,
		GenerateUID

	],

	/*
	**  Set up the data
	*/

	data: () => ({

		new_purchase: {
			id: null,
			type: 'property.purchase',
			meta: {
				created_at: moment().unix(),
				updated_at: moment().unix(),
				deleted_at: null,
				app_id: '1:KA82LQU7lsJy:eKwkfzaQy4aM:HKUl9ACoGeAQ:j1xHCCBLS7UQ:yok9xA1wrkZi',
				version: 1
			},
			attributes: {
				purchase_date: null,
				purchase_price: null
			},
			links: null,
			relationships: {
				property: null,
				user: firebaseAuth.currentUser.uid
			}
		}

	}),

	/*
	**  Set the methods
	*/

	methods: {

		createPurchase: function() {

			// Generate UID
			this.new_purchase.id = this.generateUID();

			// Create doc in database
			propertiesModel.doc(this.property.id).collection('purchases').add(this.new_purchase)
			.catch(error => {

				// Hide the spinner
				this.hideSpinner();

				// Throw warning message
    			this.$swal('Uh Oh!', error, 'error');

    			// Send to bugsnag
				this.reportAuthBugsnagError({
					title: 'Create Property Purchase - Save New Purchase in Firestore',
					errorType: 'Firestore Database',
					section: 'Create Purchase',
					component: 'PropertyPurchasesRepository',
					error: error
				});

			});

		},

		updatePurchase: function() {

			propertiesModel.doc(this.property.id).collection('purchases').doc(this.purchase.id).update({

				'attributes.purchase_price': this.purchase_price,
				'attributes.purchase_date': this.purchase_date,
				'meta.updated_at': moment().unix()

			})
			.catch(error => {

				// Send to bugsnag
				this.reportAuthBugsnagError({
					title: 'Update Property Purchase - Save in Firestore',
					errorType: 'Firestore Database',
					section: 'Update Purchase',
					component: 'PropertyPurchasesRepository',
					error: error
				});

			});

		}

	}

}